'use strict';

angular.module('docketbook').
  service('resourceService', function(accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

    this.getResourcesByCategory = function(successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');
      var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

      params = { active: true }

      // first get all resource categories
      baseResourceCategories.getList(params).then(function(resourceCategories) {
        baseResources.getList().then(function(resources) {
          var categories = {};
          for ( var i = 0; i < resourceCategories.length; i++ ) {
            categories[resourceCategories[i].id] = resourceCategories[i];
            categories[resourceCategories[i].id].resources = [];
          }
          for ( var i = 0; i < resources.length; i++ ) {
            if ( resources[i].category != null ) {
              categories[resources[i].category.id].resources.push(resources[i]);
            }
          }
          // convert categories dict to an array
          var categoriesArray = [];
          var categoriesKeys = Object.keys(categories);
          for ( var i = 0; i < categoriesKeys.length; i++ ) {
            categoriesArray.push(categories[categoriesKeys[i]]);
          }
          successCb(categoriesArray);
        }, function(err) {
          failureCb(err);
          return;
        });
      }, function(err) {
        failureCb(err);
        return;
      });
    }

    /*********************/
    /***** Resources *****/
    /*********************/

    this.getResources = function(params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      if ((!organisation) || (!organisationGroup)) {
        return successCb([]);
      }
      var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');
      if ( params == null ) {
        params = {};
      }
      if (params.active == null) {
        params.active = true;
      }
      baseResources.getList(params).then(function(resources) {
        successCb(resources);
      }, failureCb);
    }

    this.saveResource = function(resource, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

      if ( resource.id == null ) {
        resource.organisation = organisation.id;
        baseResources.post(resource).then(successCb, failureCb);
      } else {
        baseResources.one(resource.id).customPUT(resource).then(successCb, failureCb);
      }
    }

    var deleteResource = function(resourceId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

      if ( resourceId.id != null ) {
        resourceId = resourceId.id;
      }
      baseResources.one(resourceId).remove().then(successCb, failureCb);
    }

    this.removeResource = deleteResource;

    /********** Delete Bulk Resources **********/
    this.deleteBulkResources = function(resources, successCb) {
      var failures = [];
      deleteResources(resources, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteResources = function(list, index, failures, successCb) {
      if ( index >= list.length ) {
        successCb(failures);
        return;
      }

      deleteResource(list[index].id, function(success) {
        deleteResources(list, index + 1, failures, successCb);
      }, function(err) {
        failures.push(list[index]);
        deleteResources(list, index + 1, failures, successCb);
      });
    }

    this.bulkImportResources = function(resourcesList, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResourceImport = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources?import=true');

      baseResourceImport.customPOST(resourcesList).then(successCb, failureCb);
    }

    /******************************/
    /**** Resource Categories *****/
    /******************************/

    this.getResourceCategories = function(params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      if (organisation == null || organisationGroup == null) {
        if (failureCb) { failureCb() }
        return
      }

      var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

      if ( params == null ) {
        params = {};
      }
      baseResourceCategories.getList(params).then(function(categories) {
        successCb(categories);
      }, failureCb);
    }

    this.saveResourceCategory = function(resourceCategory, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

      if ( resourceCategory.id == null ) {
        resourceCategory.organisation = organisation.id;
        baseResourceCategories.post(resourceCategory).then(successCb, failureCb);
      } else {
        baseResourceCategories.one(resourceCategory.id).customPUT(resourceCategory).then(successCb, failureCb);
      }
    }

    var deleteResourceCategory = function(categoryId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

      if ( categoryId.id != null ) {
        categoryId = categoryId.id;
      }

      baseResourceCategories.one(categoryId).remove().then(successCb, failureCb);
    }

    this.removeResourceCategory = deleteResourceCategory;

    /********** Delete Bulk Resource Categories **********/
    this.deleteBulkResourceCategories = function(categories, successCb) {
      var failures = [];
      deleteResourceCategories(categories, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteResourceCategories = function(list, index, failures, successCb) {
      if ( index >= list.length ) {
        successCb(failures);
        return;
      }

      deleteResourceCategory(list[index].id, function(success) {
        deleteResourceCategories(list, index + 1, failures, successCb);
      }, function(err) {
        failures.push(list[index]);
        deleteResourceCategories(list, index + 1, failures, successCb);
      });
    }

    /***************************/
    /**** Units of Measure *****/
    /***************************/

    this.getUoms = function(params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();

      if (organisation == null || organisationGroup == null) {
        if (failureCb) { failureCb() }
        return
      }

      var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

      if ( params == null ) {
        params = {};
      }
      baseUoms.getList(params).then(function(uoms) {
        successCb(uoms);
      }, failureCb);
    }

    this.saveUom = function(uom, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

      if ( uom.id == null ) {
        uom.organisation = organisation.id;
        baseUoms.post(uom).then(successCb, failureCb);
      } else {
        baseUoms.one(uom.id).customPUT(uom).then(successCb, failureCb);
      }
    }

    var deleteUom = function(uomId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

      if ( uomId.id != null ) {
        uomId = uomId.id;
      }

      baseUoms.one(uomId).remove().then(successCb, failureCb);
    }

    this.removeUom = deleteUom;

    /********** Delete Bulk UOMS **********/
    this.deleteBulkUoms = function(uoms, successCb) {
      var failures = [];
      deleteUoms(uoms, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteUoms = function(list, index, failures, successCb) {
      if ( index >= list.length ) {
        successCb(failures);
        return;
      }

      deleteUom(list[index].id, function(success) {
        deleteUoms(list, index + 1, failures, successCb);
      }, function(err) {
        failures.push(list[index]);
        deleteUoms(list, index + 1, failures, successCb);
      });
    }
 });



// WEBPACK FOOTER //
// ./src/services/resourceService.js